import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rlynw8guiagc">
      <Hero data-id="element-1" data-mp="2mmlvl877gb6d" />
      <StatsAndProof data-id="element-2" data-mp="2mn5bykh7iria" />
      <PainPoints data-id="element-3" data-mp="2mnnfm2678808" />
      <ProductOffer data-id="element-4" data-mp="2mjzn96chprn3" />
      <Pricing showAnchor data-id="element-5" data-mp="31agq8u4rwpm3" />
      <ExtendedTestimonials data-id="element-6" data-mp="31brzh9gzmpkl" />
      <GuaranteeAndFaq data-id="element-7" data-mp="31c1l6kv02akh" />
      <CostSection data-id="element-8" data-mp="2wk0bn6p7uxy5" />
      <Pricing data-id="element-9" data-mp="2wjgq7g0cxrfd" />
      <FooterAndProofPopup data-id="element-10" data-mp="2wiywor52xrb5" />
    </main>;
}